// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_0-finance-calc {
  /* Gap */
  --perxis-auto-finance-calc-first-gap-inner: var(--perxis-auto-finance-calc-first-gap, var(--perxis-auto-gap-vertical-sky-inner));
  --perxis-auto-finance-calc-second-gap-inner: var(--perxis-auto-finance-calc-second-gap, var(--perxis-auto-gap-vertical-yellow-inner));
  /* End Gap */
  /* Colors */
  --perxis-auto-finance-calc-background-color-inner: var(--perxis-auto-finance-calc-background-color, var(--perxis-auto-root-first-color-inner));
  --perxis-auto-finance-calc-border-color-inner: var(--perxis-auto-finance-calc-border-color, var(--perxis-auto-root-fifth-color-inner));
  /* End Colors */
  /* Border */
  --perxis-auto-finance-calc-border-radius-inner: var(--perxis-auto-finance-calc-border-radius, 18px);
  --perxis-auto-finance-calc-border-width-inner: var(--perxis-auto-finance-calc-border-width, 0);
  /* End Border */
  /* Box Shadow */
  --perxis-auto-finance-calc-box-shadow-inner: var(--perxis-auto-finance-calc-box-shadow, 0px 0px 20px rgba(22, 22, 22, 0.1));
  /* End Box Shadow */
}
.perxis-auto-1_16_0-finance-calc.ant-5_17_0-card {
  padding: 0;
  margin: 0;
  border-radius: var(--perxis-auto-finance-calc-border-radius-inner);
  border-color: var(--perxis-auto-finance-calc-border-color-inner);
  border-width: var(--perxis-auto-finance-calc-border-width-inner);
  border-style: solid;
  background-color: var(--perxis-auto-finance-calc-background-color-inner);
}
.perxis-auto-1_16_0-finance-calc.ant-5_17_0-card-hoverable {
  box-shadow: var(--perxis-auto-finance-calc-box-shadow-inner);
}
.perxis-auto-1_16_0-finance-calc.ant-5_17_0-card .ant-5_17_0-card-body {
  height: 100%;
  padding: var(--perxis-auto-finance-calc-first-gap-inner);
}
.perxis-auto-1_16_0-finance-calc__header {
  margin-bottom: var(--perxis-auto-finance-calc-second-gap-inner);
  --perxis-auto-typography-h2-font-size-xxl: var(--perxis-auto-credit-calc-title-size-xl-xxl-inner);
  --perxis-auto-typography-h2-font-size-xl: var(--perxis-auto-credit-calc-title-size-xl-xxl-inner);
  --perxis-auto-typography-h2-font-size-lg: var(--perxis-auto-credit-calc-title-size-lg-inner);
  --perxis-auto-typography-h2-font-size-md: var(--perxis-auto-credit-calc-title-size-xxs-md-inner);
  --perxis-auto-typography-h2-font-size-sm: var(--perxis-auto-credit-calc-title-size-xxs-md-inner);
  --perxis-auto-typography-h2-font-size-xs: var(--perxis-auto-credit-calc-title-size-xxs-md-inner);
  --perxis-auto-typography-h2-font-size-xxs: var(--perxis-auto-credit-calc-title-size-xxs-md-inner);
}
.perxis-auto-1_16_0-finance-calc__footer {
  row-gap: var(--perxis-auto-finance-calc-first-gap-inner);
}
@media (max-width: 575px) {
  .perxis-auto-1_16_0-finance-calc__footer .perxis-auto-1_16_0-finance-calc__button-col {
    width: 100%;
  }
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
